import * as React from 'react'
import { Component } from "../Utils"

interface ActionsProps {
    schema: any;
    formId: string;
    isVisible: boolean;
    status: number;
    isPdf: boolean;
    isReportsReady: boolean;
    onSend: () => void;
    onPDF: () => void;
    onDraft: () => void;
    onDocument: () => void;
    onRevoke: () => void;
    onDelete: () => void;
    onCopy: () => void;
    onAddition: () => void;
    onShowRequestModal?: () => void;
    onShowReloadModal?: (event) => void;
}

export default class Actions extends Component<ActionsProps, null>{

    render() {
       const {
           isVisible,
           status,
           isPdf,
           isReportsReady
       } = this.props;

        return (
            <div className="reportbox-actions">
                {status === 9 && (
                    <button className="btn btn-success btn-sm pull-right" onClick={this.props.onAddition}>
                        Ответ на дозапрос
                    </button>
                )}

                {(isVisible || status === 3) ? (
                    <>
                        <button onClick={this.props.onDraft} className="btn btn-default"> Назад к заявкам </button>
                        <button onClick={this.props.onCopy} className="btn btn-warning">Копировать заявку</button>

                        {([1,2,5,6,7].indexOf(status) > -1) && (
                            <button className="btn btn-danger" onClick={this.props.onRevoke}>
                                Отозвать заявку
                            </button>
                        )}

                        {(status === 0) && (
                            <button className="btn btn-danger" onClick={this.props.onDelete}>
                                Удалить заявку
                            </button>
                        )}

                        {status !== 4 && status === 0 && !isPdf && (
                            <button className="btn btn-success btn-sm pull-right" onClick={this.props.onPDF}>
                                Сформировать PDF
                            </button>
                        )}

                        {/*
                            {isPdf && status !== 3 && (
                            <button className="btn btn-success btn-sm pull-right" onClick={this.props.onSend}>
                                Отправить заявку
                            </button>
                            )}
                        */}
                   </>
                ) : [
                    <button onClick={this.props.onDraft} className="btn btn-default">
                        Назад к заявкам
                    </button>,
                    <button onClick={this.props.onCopy} className="btn btn-warning">Копировать заявку</button>,
                    ([1,2,5,6,7].indexOf(status) > -1) && (
                        <button className="btn btn-danger" onClick={this.props.onRevoke}>
                            Отозвать заявку
                        </button>
                    )
                ]}

                {(status === 5) && (
                    <button className="btn btn-success btn-sm pull-right" onClick={this.props.onDocument}>
                        Отправить документы
                    </button>
                )}

                {(status === 12) && (
                    <div className="reportbox-actions-button-group pull-right">
                        <button className="btn btn-danger btn-sm reportbox-actions-button" onClick={this.props.onShowReloadModal}>
                            Заполнить отчет заново
                        </button>
                        <button className="btn btn-success btn-sm reportbox-actions-button" onClick={this.props.onSend}>
                            Сформировать PDF Отчёта №1
                        </button>
                        <button className="btn btn-primary btn-sm reportbox-actions-button" onClick={this.props.onShowRequestModal}>
                            Запрос продления срока предоставления отчета
                        </button>
                    </div>
                )}

                {(status === 13) && (
                    <div className="reportbox-actions-button-group pull-right">
                        <button className="btn btn-success btn-sm reportbox-actions-button" onClick={this.props.onSend}>
                            Отправить отчёт №1
                        </button>
                        <button className="btn btn-primary btn-sm reportbox-actions-button" onClick={this.props.onShowRequestModal}>
                            Запрос продления срока предоставления отчета
                        </button>
                    </div>
                )}


                {(status === 14) && (
                    <div className="reportbox-actions-button-group pull-right">
                        <button className="btn btn-danger btn-sm reportbox-actions-button" onClick={this.props.onShowReloadModal}>
                            Заполнить отчет заново
                        </button>
                        <button className="btn btn-success btn-sm reportbox-actions-button" onClick={this.props.onSend}>
                            Сформировать PDF Отчёта №2
                        </button>
                        <button className="btn btn-primary btn-sm reportbox-actions-button" onClick={this.props.onShowRequestModal}>
                            Запрос продления срока предоставления отчета
                        </button>
                    </div>
                )}

                {(status === 15) && (
                    <div className="reportbox-actions-button-group pull-right">
                        <button className="btn btn-success btn-sm reportbox-actions-button" onClick={this.props.onSend}>
                            Отправить отчёт №2
                        </button>
                        <button className="btn btn-primary btn-sm reportbox-actions-button" onClick={this.props.onShowRequestModal}>
                            Запрос продления срока предоставления отчета
                        </button>
                    </div>
                )}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/request/Actions.tsx